import React from 'react';

import classes from './BookingEngineInputContainer.scss';

const bookingEngineInputContainer = (props) => (
    <div className={classes.Container} {...props}>
        {props.children}
    </div>
);

export default bookingEngineInputContainer;


// WEBPACK FOOTER //
// ./src/components/BookingEngine/BookingEngineInputContainer/BookingEngineInputContainer.js